<template>
	<div class="">
            <div class="email">
                <div class="email-content">
                    <div class="form-group">
                        <label>Email</label>
                        <input type="text" class="form-control" v-model="email.email"  placeholder=""/>
                    </div>
                    <div class="form-group mt-2">
                        <label>Subject</label>
                        <input type="text" class="form-control" v-model="email.subject"  placeholder=""/>
                    </div>
                    <div class="form-group mt-2">
                        <VueEditor v-model="email.message" :editorToolbar="this.$customToolbar"></VueEditor>
                    </div>
                    <div class="form-group mt-2">
                        <label>Report type</label>
                        <select class="form-select" v-model="reportType">
                            <option value="completed">Completed</option>
                            <option value="noresolved">Exclude resolved</option>
                            <option value="draft">Draft</option>
                        </select>
                    </div>
                    <div class="form-group text-right">
                        <button class="btn btn-outline-primary mt-4" v-on:click="send()">Send</button>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    import { VueEditor } from "vue2-editor";
	export default {
        components: {
            VueEditor
        },
		data() {
			return {
				reportType: 'completed',
				email: {
					email: '',
					subject: 'PENETRATION TEST FINDINGS',
					message: '<p>Please find attached this month\'s Penetration Test findings.</p><p>Feel free to give us a call if you have any questions.</p>'
				}
			}
		},
		methods: {
			send() {
              let me = this;
              var url = this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/reports/email';

              if (this.reportType == "draft") {
                  url = this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/reports/email?type=draft';

              } else if (this.reportType == "noresolved") {
				url = this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/reports/email?type=noresolved';
              }

              this.$axios.post(url, this.email)
                .then(res => {
                    var r = res.data;
                    if (r.success) {
                        me.$swal({
                           title: r.message
                        });

                        me.$emit("callback", true);

                    } else {
                        me.$swal({
                           title: r.message,
                           icon: 'error'
                       });
                    }
                });
			}
		}
	}
</script>